import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData } from '../types';

export function CostAndMOQSection() {
  const { control } = useFormContext<AddTagFormData>();

  const costValidation = {
    valueAsNumber: true,
    min: {
      value: 0,
      message: 'Cost must be greater than or equal to 0',
    },
  };

  const moqValidation = {
    valueAsNumber: true,
    min: {
      value: 1,
      message: 'MOQ must be at least 1',
    },
  };

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-4">
          <ControlledFormInput
            name="juniorCost"
            label="JR Cost"
            required
            control={control}
            inputType="currency"
            rules={costValidation}
            inputProps={{
              currency: '$',
              step: '0.01',
              placeholder: '0.00',
              min: '0.00',
            }}
          />
          <ControlledFormInput
            name="juniorMoq"
            label="JR MOQ"
            control={control}
            inputType="number"
            rules={moqValidation}
            inputProps={{
              min: '1',
            }}
          />
        </div>

        <div className="space-y-4">
          <ControlledFormInput
            name="plusCost"
            label="Plus Cost"
            control={control}
            inputType="currency"
            rules={costValidation}
            inputProps={{
              currency: '$',
              step: '0.01',
              placeholder: '0.00',
              min: '0.00',
            }}
          />
          <ControlledFormInput
            name="plusMoq"
            label="Plus MOQ"
            control={control}
            inputType="number"
            rules={moqValidation}
            inputProps={{
              min: '1',
            }}
          />
        </div>
      </div>
    </div>
  );
}
